/**
 * UnifiedToggle — веб-версия переключателя как в mobile
 * Системный стиль switch с primary цветом
 */

import React from 'react';
import './UnifiedToggle.css';

export interface UnifiedToggleProps {
  value: boolean;
  onValueChange: (value: boolean) => void;
  disabled?: boolean;
  label?: string;
  description?: string;
  size?: 'default' | 'small';
  accessibilityLabel?: string;
}

export function UnifiedToggle({
  value,
  onValueChange,
  disabled = false,
  label,
  description,
  size = 'default',
  accessibilityLabel,
}: UnifiedToggleProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!disabled) {
      if (window.Telegram?.WebApp?.HapticFeedback) {
        window.Telegram.WebApp.HapticFeedback.impactOccurred('light');
      }
      onValueChange(e.target.checked);
    }
  };

  const handleLabelClick = () => {
    if (!disabled) {
      onValueChange(!value);
    }
  };

  const switchEl = (
    <label
      className={`unified-toggle unified-toggle--${size} ${disabled ? 'unified-toggle--disabled' : ''}`}
      aria-label={accessibilityLabel || label}
    >
      <input
        type="checkbox"
        checked={value}
        onChange={handleChange}
        disabled={disabled}
        className="unified-toggle__input"
        role="switch"
        aria-checked={value}
      />
      <span className="unified-toggle__slider" />
    </label>
  );

  if (label) {
    return (
      <div
        className={`unified-toggle-row ${disabled ? 'unified-toggle-row--disabled' : ''}`}
        role="switch"
        aria-checked={value}
        aria-label={accessibilityLabel || label}
      >
        <div className="unified-toggle-row__label" onClick={handleLabelClick}>
          <span className="unified-toggle-row__text">{label}</span>
          {description && (
            <span className="unified-toggle-row__desc">{description}</span>
          )}
        </div>
        {switchEl}
      </div>
    );
  }

  return switchEl;
}

export default UnifiedToggle;
